import {RootState} from "@/store";
import {Module} from "vuex";
import UserService from "@/services/users/UserService";

export interface BalanceState {
    currentBalance: number
    isUnlimitedBalance: boolean
    isLoadingBalance: boolean
    hasShownLowBalanceAlert: boolean
    royalties: number
    royaltiesStatus: 'PENDING' | 'PAID' | 'EXEMPT' | 'NOT_APPLICABLE'
    isLoadingRoyalties: boolean
}

const balance: Module<BalanceState, RootState> = {
    namespaced: true,
    state: {
        currentBalance: 0,
        isUnlimitedBalance: false,
        isLoadingBalance: false,
        hasShownLowBalanceAlert: false,
        royalties: 0,
        royaltiesStatus: 'EXEMPT',
        isLoadingRoyalties: false,
    },
    mutations: {
        SET_BALANCE(state, newBalance: number) {
            state.currentBalance = newBalance;
        },
        SET_LOADING_BALANCE(state, isLoading: boolean) {
            state.isLoadingBalance = isLoading;
        },
        SET_UNLIMITED_BALANCE(state, isUnlimited: boolean) {
            state.isUnlimitedBalance = isUnlimited;
        },
        SET_HAS_SHOWN_LOW_BALANCE_ALERT(state, hasShown: boolean) {
            state.hasShownLowBalanceAlert = hasShown;
        },
        SET_ROYALTIES(state, royalties: number) {
            state.royalties = royalties;
        },
        SET_ROYALTIES_STATUS(state, status: 'PENDING' | 'PAID' | 'EXEMPT' | 'NOT_APPLICABLE') {
            state.royaltiesStatus = status;
        },
        SET_LOADING_ROYALTIES(state, isLoading: boolean) {
            state.isLoadingRoyalties = isLoading;
        }
    },
    actions: {
        async updateBalance({commit}) {
            commit('SET_LOADING_BALANCE', true);
            try {
                const response = await UserService.getUserBalance();
                commit('SET_BALANCE', response.balance);
                commit('SET_UNLIMITED_BALANCE', response.isUnlimited);
            } finally {
                commit('SET_LOADING_BALANCE', false);
            }
        },
        async updateRoyalties({commit}) {
            commit('SET_LOADING_ROYALTIES', true);
            try {
                const response = await UserService.getUserRoyalties();
                commit('SET_ROYALTIES', response.royalties);
                commit('SET_ROYALTIES_STATUS', response.royaltiesStatus);
            } finally {
                commit('SET_LOADING_ROYALTIES', false);
            }
        }
    },
    getters: {
        getCurrentBalance: state => state.currentBalance,
        isUnlimitedBalance: state => state.isUnlimitedBalance,
        isBalanceLoading: state => state.isLoadingBalance,
        hasShownLowBalanceAlert: state => state.hasShownLowBalanceAlert,
        getCurrentRoyalties: state => state.royalties,
        getRoyaltiesStatus: state => state.royaltiesStatus,
        isRoyaltiesLoading: state => state.isLoadingRoyalties,
    }
}

export default balance